import { render, staticRenderFns } from "./TimelineSegmentEditor.vue?vue&type=template&id=5bc4df6a&scoped=true&"
import script from "./TimelineSegmentEditor.vue?vue&type=script&lang=js&"
export * from "./TimelineSegmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./TimelineSegmentEditor.vue?vue&type=style&index=0&id=5bc4df6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4df6a",
  null
  
)

export default component.exports